// extracted by mini-css-extract-plugin
export default {"cls1":"RinZyIj1AwnpMf6FcLr4","cls2":"ky8IFvfhw9zLqQWFUmd4 RinZyIj1AwnpMf6FcLr4","isPhone":"G9IdOnnjbOP6vyy7RNTj"};